import api, { TDataMyPage, TUpdateDataMyPageRequest } from '.';

const getDataMyPage = async () => await api.get<TDataMyPage>('/account/myinfo');

const updateDataMyPage = async (data: TUpdateDataMyPageRequest) =>
	await api.post('/account/myinfo', data);

export { getDataMyPage, updateDataMyPage };
